import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from "moment";
import { MessageService } from "primeng/api";
import { AppMainService } from 'src/app/app-main.service';
import { AppMainComponent } from 'src/app/app.main.component';
import { SOChannel } from 'src/app/inventory/sales-order/constants/constants';
import { CalendarEventService, EmailAuditService, TaskService } from 'src/app/shared/api/api';
import { CalendarEvent, EmailAudit } from 'src/app/shared/model/models';
import { ObjectNames } from "../../../constants/object.names";
import { TaskCategory } from "../../../model/models";
import { LionSharedEmailsComponent } from '../../shared-emails/shared-emails.component';
import { GlobalSearchPath } from '../../../constants/global-search-path';
import { ActivityService } from "../activity.service";
import { LogService, NoteService } from "../api/api";
import { CONTACT_ASSOCIATION_IDS_MODULES } from '../../../constants/typeId';
import { environment } from 'src/environments/environment';
import { CaseModuleId, CMOrderModuleId, ContactModuleId, CustomerRMAModuleId, EstimateOrderModuleId, InvoiceOrderModuleId, OpportunityModuleId, SOModuleId, TaskModuleId } from '../../../constants/modules.constant';
import { TransactionNames } from 'src/app/finance/constants/constants';
import { DomSanitizer } from '@angular/platform-browser';
import { ReadActivitiesByIdsPayload } from '../../../models/activity-list-payload.model';

@Component({
	selector: "app-shared-activity-list-template",
	templateUrl: "./shared-activity-list-template.component.html",
	styleUrls: ["./shared-activity-list-template.component.scss"],
	providers: [
		LogService,
		NoteService,
		ActivityService,
		CalendarEventService,
		TaskService,
	],
})

export class SharedActivityListTemplateComponent implements OnChanges, OnInit {

	@Input() channelId: number;
	@Input() objectId;
	@Input() objectTypeId;
	@Input() selectedObject;
	@Input() objectType;
	@Input() currentStageId;
	@Input() contacts;
	@Input() selectedObjectStages = [];
	@Input() isViewMode = false;
	@Input() showActivityLoader: boolean = true;
	@Input() allActivityLogs: any[] = [];

	@Output() object = new EventEmitter();
	@Output() taskAdded = new EventEmitter<any>();
	@Output() getActivityTimelineList = new EventEmitter<any>();


	@ViewChild(LionSharedEmailsComponent) lionSharedEmailsComponent: LionSharedEmailsComponent;

	displayTaskDetails = false;
	displayEditEvent = false;
	task;
	note;
	log;
	eventMode = "";
	event: CalendarEvent;
	emailAudit: EmailAudit;
	showSpinner: boolean = false;

	filters = {
		ALL_ACTIVITY: 'allactivity',
		USER_ACTIVITY: 'useractivity',
		SYSTEM_ACTIVITY: 'systemactivity',
		LOG: 'log',
		NOTE: 'note',
		EMAIL: 'email',
		FAVORITE: 'favorite'
	};

	//comment modal
	displayCommentAdd: boolean = false;
	tempComment;
	nextStageIdForUpdate;
	commentFormType;
	filterType = "allactivity";

	dataId;
	objectNames = ObjectNames;
	emailAuditId;
	refreshEmailAuditId: number = 0;

	currentObjectType;
	commentHeaderName: string;

	activityLogsData: Array<any>;
	activitySidebar = false;

	displaySendEmail = false;
	displayAddLog = false;
	displayNotesAdd = false;
	isView = true;

	//task
	displayTaskDetail = false;
	taskTemp = {
		"id": 0,
		"user": "",
		"date": "",
		"fromTime": "",
		"endTime": "",
		"header": "",
		"message": "",
		"type": "Task",
		"email": "",
		"status": "",
		"taskId": "",
		"taskStatus": "",
		"assignedTo": "",
		"category": "",
		"relatedTo": "",
		"repeatType": "",
		"timezone": "",
		"description": "",
		"taskStatuses": [
			{
				id: 0,
				createdByName: this.app.user.name,
				createdDate: new Date(),
				taskStatus: "Assigned"
			},
		]
	}
	activeUsers = [];
	selectedUsers = [];
	taskCategories: TaskCategory[] = [];
	selectedTaskCategory;
	taskStatuses: [
		{ id: 1, name: "Assigned" },
		{ id: 2, name: "In Progress" },
		{ id: 3, name: "Completed" },
		{ id: 4, name: "Accepted" },
	];
	selectedTaskStatus;
	showStatusValidation: boolean = false;
	uploadedFiles: any[] = [];

	//log & note
	displayLogDetailPopup = false;
	displayNoteDetailPopup = false;
	logData;
	noteData;
	//event
	displayEventDetail = false;
	eventTemp = {
		"id": 0,
		"user": "",
		"date": "",
		"fromTime": "",
		"endTime": "",
		"header": "",
		"message": "",
		"type": "Event",
		"email": "",
		"userLists": [],
		"location": ""
	};
	allUsersList: any[];
	usersList = [];
	isShownOptional = false;
	minimumDate: Date;
	evtMsg = "";

	//email
	displayEmailDetail = false;

	displayEmailDetailPopup = false;
	emailData;

	//activity list
	displayAllActivityLists = false;
	//system generated
	caseTemp = {
		"id": 0,
		"user": "",
		"date": "",
		"header": "",
		"message": "",
		"type": "Case",
		"taskId": "",
		"filter": "system",
		"category": "",
		"subCategory": "",
		"mark": false,
		"comments": []
	};

	displayOverviewPopup: boolean = false;
	displayDetailPopup = false;
	popupHeader = '';
	moduleName = '';
	moduleType = '';
	itemRouterLink = '';
	detailsData;
	favoriteClicked = false;

	// Active / Inactive

	activeInactiveFormType: string;
	displayActiveInactiveModal: boolean = false;
	activeInactiveData: any;

	// Email Reply
	displayEmailReplyPopup: boolean = false;
	emailReplyData: any;

	soChannel = SOChannel;

	paths = GlobalSearchPath;

	associationTypeId: number = 0;
	assestBaseUrl: string = environment.assestsBasePath;
	//Inventory Overview
	transactionNames = TransactionNames;
	displayInventoryOverview: boolean = false;
	inventoryOverviewRefId: number = 0;
	inventoryOverviewRefNumber: string = "";
	inventoryOverviewModule: string = "";
	selectedUserId: any;
	displayUserDetails = false;
	private documentClickListener!: () => void;
	constructor(
		public app: AppMainComponent,
		private router: Router,
		private activityService: ActivityService,
		private noteService: NoteService,
		private logService: LogService,
		private appMainService: AppMainService,
		private emailAuditService: EmailAuditService,
		private messageService: MessageService,
		private datePipe: DatePipe, private sanitizer: DomSanitizer
	) { }

	ngOnInit(): void {
		this.activeUsers = this.app.usersList.filter(obj => obj.statusId == 1);
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes && changes.selectedObject && changes.selectedObject.currentValue) {
			this.selectedObject = changes.selectedObject.currentValue;
		}

		if (changes && changes.allActivityLogs && changes.allActivityLogs.currentValue) {
			const responses= changes.allActivityLogs.currentValue.map(comment => (
				{ ...comment, viewDescription: this.sanitizer.bypassSecurityTrustHtml(comment.description), }));
			  this.allActivityLogs = responses;
		}

		if (changes && changes.selectedObjectStages && changes.selectedObjectStages.currentValue) {
			this.selectedObjectStages = changes.selectedObjectStages.currentValue;
		}

		if (changes && changes.objectType && changes.objectType.currentValue) {
			this.currentObjectType = changes.objectType.currentValue;
		}

		if (changes?.isViewMode?.currentValue) {
			this.isViewMode = changes.isViewMode.currentValue;
		}
	}
    ngAfterViewInit() {
        this.documentClickListener = this.handleDocumentClick.bind(this);
        document.addEventListener('click', this.documentClickListener);
      }

      private handleDocumentClick(event: MouseEvent) {
        const target = event.target as HTMLElement;
        const mentionElement = target.closest('.mention');

        if (mentionElement) {
          event.stopPropagation();
          const userId = mentionElement.getAttribute('data-id');
          if (userId && userId !== this.selectedUserId) {
            this.openTaggedUserDetails(userId);
          }
        }
      }
	    //#region Tagged User Details Popup
  openTaggedUserDetails(userId: any) {
    this.selectedUserId = userId;
    this.displayUserDetails = true;
  }
  closeTaggedUserDetails(){
    this.selectedUserId = null;
    this.displayUserDetails = false;
  }
	toggleFavourite(id, isFavorite, s) {
		this.favoriteClicked = true;
		let filterValue = s.activityName;

		this.appMainService.isShowSpinner("toggleFavourite");

		this.activityService.toggleFavourite(id, isFavorite, filterValue.toLowerCase())
			.then(() => {
				this.appMainService.isHideSpinner("toggleFavourite");

				let summary = filterValue;
				summary += isFavorite ? ' added to favorites' : ' removed from favorites';

				this.messageService.add({ severity: 'success', summary, detail: '' });
				s.isFavorite = isFavorite;

				this.favoriteClicked = false;
			})
			.catch(() => {
				this.appMainService.isHideSpinner("toggleFavourite");
				this.favoriteClicked = false;
			})
	}

	openUpdateStagePopup(data: { id: number, type: string, comment?: Comment }) {
		this.displayCommentAdd = true;
		this.selectedObject = this.selectedObject;
		this.tempComment = data.comment;
		this.nextStageIdForUpdate = data.id;
		this.commentFormType = data.type;
		if (this.tempComment.objectType == 'Lead') {
			this.commentHeaderName = `${this.tempComment.objectType} Name : ${this.selectedObject.businessName}`;
		}
		else if (this.tempComment.objectType == 'Case') {
			this.commentHeaderName = `${this.tempComment.objectType} No : ${this.tempComment.moduleData?.sequenceNumber || this.selectedObject.sequenceNumber}`;
		}
		else {
			this.commentHeaderName = `${this.tempComment.objectType} Name : ${this.tempComment.moduleData?.name || this.selectedObject?.name}`;
		}
	}
	getTruncatedDescription(description: string): string {
		if (!description) return '';
		return description.length > 343 ? description.substring(0, 343) + '...' : description;
	  }
	onCommentSaved(event) {
		this.displayCommentAdd = false;
		event && event.comment &&
			this.object.emit(
				{
					formType: event.formType,
					comment: event.comment,
					objectRecordId: event.objectRecordId
				}
			);
	}

	onCancelComment() {
		this.displayCommentAdd = false;
	}

	commentCancelClicked() {
		this.displayCommentAdd = false;
	}

	onCommentDelete() {
		this.displayCommentAdd = false;
	}

	openActivityDetail(s,event) {
		const target = event.target as HTMLElement;
		const mentionElement = target.closest('.mention');
		if (mentionElement) {
		  return
		}
		s['isRead'] = true;
		if (this.favoriteClicked) {
			return;
		}

		if (s.activityName == this.objectNames.LOG || (s.activityName=='Comment' && s.type != this.objectNames.NOTE)) {
			this.openLogDetail(s);
		} else if (s.type == this.objectNames.NOTE) {
			this.openNoteDetail(s);
		} else if (s.activityName == this.objectNames.EMAIL) {
			this.emailAudit = null;
			this.openEmailDetail(s);
		}
		else if (s.type == this.objectNames.LEAD) {
			this.openLeadDetail(s, s.objectData?.objectRecordId);
		}
		else if (s.type == this.objectNames.CONTACT) {
			this.openContactDetail(s);
		} else if (s.type == this.objectNames.ACCOUNT && s.objectData?.action != 'Convert') {
			this.openAccountDetail(s, s.objectData?.objectRecordId);
		} else if (s.type == this.objectNames.ACCOUNT && s.objectData?.action == 'Convert') {
			if (s.objectData?.objectId == 2) {
				this.openLeadDetail(s, this.selectedObject?.leadId);
			} else {
				this.openAccountDetail(s, this.selectedObject?.accountId);
			}

		} else if (s.type == this.objectNames.OPPORTUNITY) {
			this.openOpportunityDetail(s);
		} else if (s.type == this.objectNames.CASE) {
			this.openCaseDetail(s);
		} else if (s.type == 'Invoice') {
			this.openInventoryOverview(this.transactionNames.Invoice, "", s?.moduleData?.objectRecordId);
		} else if (s.type == 'SalesOrder') {
			this.openInventoryOverview(this.transactionNames.SalesOrder, "", s?.moduleData?.objectRecordId);
		} else if (s.type == 'CustomerRma') {
			this.openInventoryOverview(this.transactionNames.CustomerRMA, "", s?.moduleData?.objectRecordId);
		} else if (s.type == 'CreditMemo') {
			this.openInventoryOverview(this.transactionNames.CreditMemo, "", s?.moduleData?.objectRecordId);
		} else if (s.type == 'Estimate') {
			this.openInventoryOverview(this.transactionNames.Estimate, "", s?.moduleData?.objectRecordId);
		}
		else if (s.type == 'ActivityLeadLog' || s.type == 'ActivityOpportunityLog' || s.type == 'ActivityCasesLog') {
			if (s.objectData) {
				let activity = s.objectData;
				if (s.moduleData) {
					activity.moduleData = s.moduleData;
				}
				activity['objectType'] = s.type == 'ActivityLeadLog' ? 'Lead' :
					s.type == 'ActivityOpportunityLog' ? 'Opportunity' : 'Case';
				activity['userName'] = s.activityByUserName;
				this.openUpdateStagePopup({ id: activity.stageId, type: 'View', comment: activity });
			}
		}
		else if (s.type == 'StageChange') {
			if (s.objectData) {
				let activity = s.objectData;
				activity['objectType'] = 'Case';
				this.commentFormType = 'Add'; // For hidding
				activity['userName'] = s.activityByUserName;
				this.openUpdateStagePopup({ id: activity?.StageId, type: 'View', comment: activity });
			}
		}
		else if (s.type == 'ActiveInactiveContactLog' || s.type == 'ActiveInactiveOpportunityLog'
			|| s.type == 'ActiveInactiveAccountLog' || s.type == 'ActiveInactiveLeadLog') {
			if (s.objectData) {
				s.objectData['objectType'] = s.type == 'ActiveInactiveLeadLog' ? 'Lead' :
					s.type == 'ActiveInactiveOpportunityLog' ? 'Opportunity' :
						s.type == 'ActiveInactiveAccountLog' ? 'Account' : 'Contact';
				this.openActiveInactiveModal(s);
			}
		}
		else if (s.type == 'EmailReply') {
			this.openEmailReplyPopup(s);
		}
	}

	openRecordDetails(s: any) {
		switch (s?.moduleData?.objectId) {
			case OpportunityModuleId:
				s.objectData.objectRecordId = s?.moduleData?.objectRecordId;
				this.openOpportunityDetail(s);
				break;
			case CaseModuleId:
				s.objectData.objectRecordId = s?.moduleData?.objectRecordId;
				this.openCaseDetail(s);
				break;
			case ContactModuleId:
				s.objectData.objectRecordId = s?.moduleData?.objectRecordId;
				this.openContactDetail(s);
				break;
			case TaskModuleId:
				s.objectData.sequenceNumber = s?.moduleData?.sequenceNumber;
				this.openTaskDetail(s.objectData.sequenceNumber);
				break;
			case InvoiceOrderModuleId:
				this.openInventoryOverview(this.transactionNames.Invoice, "", s?.moduleData?.objectRecordId);
				break;
			case SOModuleId:
				this.openInventoryOverview(this.transactionNames.SalesOrder, "", s?.moduleData?.objectRecordId);
				break;
			case CustomerRMAModuleId:
				this.openInventoryOverview(this.transactionNames.CustomerRMA, "", s?.moduleData?.objectRecordId);
				break;
			case CMOrderModuleId:
				this.openInventoryOverview(this.transactionNames.CreditMemo, "", s?.moduleData?.objectRecordId);
				break;
			case EstimateOrderModuleId:
				this.openInventoryOverview(this.transactionNames.Estimate, "", s?.moduleData?.objectRecordId);
				break;
		}
	}

	openActiveInactiveModal(data: any): void {
		let moduleName: string = '';
		switch (data?.type) {
			case 'ActiveInactiveContactLog':
				moduleName = 'Contacts';
				break;
			case 'ActiveInactiveOpportunityLog':
				moduleName = 'Opportunity';
				break;
			case 'ActiveInactiveLeadLog':
				moduleName = 'Lead';
				break;
			case 'ActiveInactiveAccountLog':
				moduleName = 'Account';
				break;
		}
		const status: string = (data?.objectData?.status?.id == 1) ? 'Active' : 'Inactive';
		this.commentHeaderName = moduleName + ' ' + status + ' Details';
		this.activeInactiveFormType = 'View';
		this.displayActiveInactiveModal = true;
		this.activeInactiveData = data;
		this.moduleName = moduleName;
	}

	cancelActiveInactiveModal(): void {
		this.commentHeaderName = '';
		this.activeInactiveFormType = '';
		this.moduleName = '';
		this.displayActiveInactiveModal = false;
		this.activeInactiveData = null;
	}

	openLogDetail(s) {
		this.logService.lionO36020APILogIdGet(s.objectData.log.id).subscribe((log: any) => {
			this.logData = log;
			this.displayLogDetailPopup = true;

            const unreadComments: ReadActivitiesByIdsPayload[] = this.logData.logComments.filter(n=> n.isRead===false).map(log=>{
                return {
                    objectId: this.objectTypeId,
                    objectRecordId: this.objectId,
                    logType: 'Comment',
                    logId: log?.commentId
                }
            });

            if(this.logData?.isRead===false){
                unreadComments.push({
                    objectId: this.objectTypeId,
                    objectRecordId: this.objectId,
                    logType: 'Log',
                    logId: this.logData?.id
                })
            }

            if(unreadComments?.length>0){
                this.unreadActivities(unreadComments);
            }
		});

		this.activitySidebar = false;
	}

	cancelLogPopupDetails() {
		this.logData = null;
		this.displayLogDetailPopup = false;
	}

	openNoteDetail(s) {
		this.noteService.lionO36020APINoteIdGet(s.objectData.note.id).subscribe(note => {
			this.noteData = note;
			this.displayNoteDetailPopup = true;

            const unreadComments: ReadActivitiesByIdsPayload[] = this.noteData.noteComments.filter(n=> n.isRead===false).map(note=>{
                return {
                    objectId: this.objectTypeId,
                    objectRecordId: this.objectId,
                    logType: 'Comment',
                    logId: note?.commentId
                }
            });

            if(this.noteData?.isRead===false){
                unreadComments.push({
                    objectId: this.objectTypeId,
                    objectRecordId: this.objectId,
                    logType: 'Note',
                    logId: this.noteData?.id
                })
            }

            if(unreadComments?.length>0){
                this.unreadActivities(unreadComments);
            }
		});

		this.activitySidebar = false;
	}

	cancelNotePopupDetails() {
		this.noteData = null;
		this.displayNoteDetailPopup = false;
		//this.app.getAllActivityLog("lastsevendays", "allactivity", 1, 10, "", true, true);
	}

	openTaskDetail(taskId) {
		this.app.selectedTaskId = taskId;
		this.app.displayEditViewTask = true;
	}

	openEventDetail(s) {
		this.eventTemp = JSON.parse(JSON.stringify(s));
		this.allUsersList = [...this.app.usersList];

		let date = this.datePipe.transform(this.eventTemp.fromTime, 'MM/dd/yyyy');
		let from = this.datePipe.transform(this.eventTemp.fromTime, 'HH:mm a');
		let end = this.datePipe.transform(this.eventTemp.endTime, 'HH:mm a');
		this.evtMsg = "This event will take place on " + date + " from " + from + " to " + end;

		this.displayEventDetail = true;
		this.isView = true;
	}

	openEmailDetail(s) {
		this.displayEmailDetailPopup = true;
		this.emailAuditId = s.objectData.objectEmailAudit.emailAuditId;
		this.emailAuditService.lionO36020APIEmailAuditIdGet(this.emailAuditId, true).subscribe((email: any) => {
			let emailAuditDetails: EmailAudit = email;
			emailAuditDetails.emailThreads.forEach(elem => { elem.receivedDateTime = elem.receivedDateTime });
			emailAuditDetails.emailThreads = emailAuditDetails.emailThreads.sort(function (left, right) {
				return moment.utc(right.receivedDateTime).diff(moment.utc(left.receivedDateTime))
			});
			this.emailAudit = emailAuditDetails;
		});
	}

	openLeadDetail(s: any, leadId: number) {
		this.moduleType = this.objectNames.LEADS;
		this.displayOverviewPopup = true;
		this.popupHeader = "Lead Details";
		this.dataId = leadId;
	}

	openContactDetail(s) {
		this.moduleType = this.objectNames.CONTACT;
		this.displayDetailPopup = true;
		this.popupHeader = "Contact Details";
		this.dataId = s?.objectData?.objectRecordId;
		this.associationTypeId = CONTACT_ASSOCIATION_IDS_MODULES[`OBJECTID_${s?.objectData?.refObjectId}`];
	}

	openAccountDetail(s: any, accountId: number) {
		this.moduleType = this.objectNames.ACCOUNT;
		this.displayOverviewPopup = true;
		this.popupHeader = "Account Details";
		this.dataId = accountId;
	}

	openOpportunityDetail(s) {
		this.moduleType = this.objectNames.OPPORTUNITY;
		this.displayOverviewPopup = true;
		this.popupHeader = "Opportunity Details";
		this.dataId = s?.objectData?.objectRecordId;
	}

	openCaseDetail(s) {
		this.moduleType = this.objectNames.CASES;
		this.displayOverviewPopup = true;
		this.popupHeader = "Case Details";
		this.dataId = s?.objectData?.objectRecordId;
	}

	cancelEmailPopupDetails() {
		this.emailData = null;
		this.displayEmailDetailPopup = false;
	}

	openEmailReplyPopup(data: any): void {
		this.displayEmailReplyPopup = true;
		this.getEmailReplyActivity(data?.id||data?.objectData?.id);
	}

	getEmailReplyActivity(id: number): void {
		this.appMainService.isShowSpinner("emailReplyActivity");
		this.activityService.getEmailReplyActivity(id).then((response) => {
			this.emailReplyData = response;
			this.appMainService.isHideSpinner("emailReplyActivity");
		},
			(error) => {
				this.messageService.add({ severity: 'error', summary: 'Error Occured', detail: error?.error?.message });
				this.appMainService.isHideSpinner("emailReplyActivity");
			});
	}

	cancelEmailReplyPopup(): void {
		this.displayEmailReplyPopup = false;
		this.emailReplyData = null;
	}

	onUpload(event) {
		for (let file of event.files) {
			this.uploadedFiles.push(file);
		}

		this.messageService.add({ severity: 'info', summary: 'File Uploaded', detail: '' });
	}

	//activity list
	search(query) {
		const filtered: any[] = [];
		for (let l of this.allUsersList) {
			if (l.name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
				filtered.push(l);
			}
		}
		this.usersList = [...filtered];
	}

	showOptional() {
		this.isShownOptional = !this.isShownOptional;
	}

	openAllActivityList() {
		this.displayAllActivityLists = true;
	}

	emailSync(emailAuditId: number = 0) {
		this.showSpinner = true;
		this.activityService.getEmailSync(this.objectId, this.app.objectTypeId ?? this.objectTypeId, emailAuditId).subscribe(
			{
				next: (res) => {
					this.showSpinner = false;
					this.app.getAllObjects();
				},
				error: (error) => {
					this.showSpinner = false;
				}
			});
	}

	closeActivityDialog() {
		this.displayAllActivityLists = false;
	}

	setDetailsPopupData(s) {
		this.displayDetailPopup = true;
		this.moduleName = s.type;
		this.popupHeader = s.type + ' Details';
	}

	closeDialog() {
		this.displayOverviewPopup = false;
		this.displayDetailPopup = false;
	}

	cancelEmail(event) {
		this.displaySendEmail = event.cancelEmail;
	}

	cancelLog(event) {
		this.displayAddLog = event.cancelEmail;
	}

	cancelNote(event) {
		this.displayNotesAdd = event.cancelEmail;
	}

	newTaskAdded() {
		this.taskAdded.emit({ "taskAdded": true });
	}

	convertPageNavigation(s) {
		let url = "";
		let businessName = "";
		let splitedText = s.objectData.comment.split(':');
		if (s?.objectData?.comment && splitedText.length > 1) {
			businessName = splitedText[1]?.trim();
		}

		let queryParams = {
			id: 0,
			channelId: this.selectedObject?.typeId || 1,
			module: s.type,
			statusId: 1,
			globalSearch: true,
			data: businessName,
		};

		if (s.objectData?.objectId == 2) {
			url = this.paths.Lead;
			queryParams.id = this.selectedObject?.leadId;
			queryParams.module = 'Leads';
		} else {
			url = this.paths.Account;
			queryParams.id = this.selectedObject?.accountId;
			queryParams.module = 'Account';
		}

		this.router
			.navigateByUrl("/", { skipLocationChange: true })
			.then(() =>
				this.router.navigate([url], {
					queryParams
				})
			);
	}

	syncSendEmail(mailObj: any) {
		this.app.loadingActivityLogs = true;
		setTimeout(() => {
			this.emailSync(mailObj?.emailAudit?.id ?? mailObj?.emailAuditId ?? 0);
		}, 2000);
	}

	getSequenceNumber(s: any): string {
		try {
			const payloadData = this.parsePayload(s);
			return payloadData?.SequenceNumber || '';
		} catch (error) {
			console.error('Error getting sequence number:', error);
			return '';
		}
	}

	getCurrentStage(s: any): string {
		try {
			const payloadData = this.parsePayload(s);
			return payloadData?.CurrentStage ||
				(payloadData?.Status?.Name) || '';
		} catch (error) {
			console.error('Error getting current stage:', error);
			return '';
		}
	}

	getNetAmount(s: any): string {
		try {
			const payloadData = this.parsePayload(s);
			return payloadData?.NetAmount || '0';
		} catch (error) {
			console.error('Error getting total amount:', error);
			return '0';
		}
	}

	getOpportunityName(s: any): string {
		try {
			const payloadData = this.parsePayload(s);
			return payloadData?.Name || '0';
		} catch (error) {
			console.error('Error getting total amount:', error);
			return '0';
		}
	}

	private parsePayload(s: any): any {
		if (s?.objectData?.activityFeedPayload?.payload) {
			const payloadData = s.objectData.activityFeedPayload.payload;

			try {
				// If payload is a string, parse it
				if (typeof payloadData === 'string') {
					return JSON.parse(payloadData);
				}
				// If payload is an object with a payload property
				else if (payloadData.payload && typeof payloadData.payload === 'string') {
					return JSON.parse(payloadData.payload);
				}
				// If payload is already an object
				return payloadData;
			} catch (error) {
				console.error('Error parsing payload:', error);
				return {};
			}
		}
		return {};
	}

	//#region inventory modal
	openInventoryOverview(moduleName: string, title: string, id: number = 0) {
		this.inventoryOverviewRefId = id;
		this.inventoryOverviewRefNumber = title;
		this.inventoryOverviewModule = moduleName;
		this.displayInventoryOverview = true;
	}

	closeViewPopup() {
		this.displayInventoryOverview = false;
	}

	refreshEmail(emailAuditId, event) {
		event.stopPropagation();
		this.showSpinner = true;
		this.refreshEmailAuditId = emailAuditId;

		this.activityService.getEmailSync(this.objectId, this.objectTypeId, emailAuditId).subscribe(
			{
				next: (res) => {
					this.showSpinner = false;
					this.refreshEmailAuditId = 0;
					this.getActivityTimeline(true);
				},
				error: (error) => {
					this.showSpinner = false;
					this.refreshEmailAuditId = 0;
				}
			});
	}
	getActivityTimeline(refreshWithoutLoading: boolean = false) {
		this.getActivityTimelineList.emit(refreshWithoutLoading);
	}

    unreadActivities(unreadActivities: ReadActivitiesByIdsPayload[]){
        this.activityService.readActivitiesByIds(unreadActivities)
        .subscribe({
            next: () => {},
            error: (error) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error?.error?.Message ?? 'Error updating activity status'
                });
            }
        });;
    }

	ngOnDestroy() {
        document.removeEventListener('click', this.documentClickListener);
    }
}
